module.exports = __webpack_public_path__ + "static/media/townhouse.7691b355.png";